export default class EmployeeInsuranceFilteredDashboard {
  tsdNo: number;
  akaName: string;
  annualPay: number;
  healthCode: string;

  health?: number;
  companyHealth?: number;
  employeeHealth?: number;

  disability?: number;
  companyDisability?: number;
  employeeDisability?: number;

  dental?: number;
  companyDental?: number;
  employeeDental?: number;

  life?: number;
  companyLife?: number;
  employeeLife?: number;

  vision?: number;
  companyVision?: number;
  employeeVision?: number;

  total?: number;
  companyTotal?: number;
  employeeTotal?: number;

  defined: string;
  active: string;
}



// WEBPACK FOOTER //
// ./src/models/personnel/EmployeeInsuranceFilteredDashboard.ts